module.exports = __webpack_public_path__ + "static/media/aiva_features_image.7c818e69.png";